/*
  Formulieren rechtstreeks naar MailerLite (account van Food to Shine).

  Een formulier met data-fts-mailerlite="<formulier-ID>" wordt niet naar
  Shopify gestuurd, maar naar het MailerLite-formulier met dat ID. Daar
  bepaalt MailerLite de groep, de dubbele bevestiging en de automatische
  mails (bijv. de 3 dagen regel). Er staat geen API-sleutel in de site:
  dit is hetzelfde adres dat de ingesloten MailerLite-formulieren op de
  oude site gebruikten.

  Velden: het e-mailveld (type=email) en, als die er is, een naamveld
  (name="naam" of name="contact[first_name]"). Na verzenden verschijnt
  het element [data-fts-ml-bedankt] en verdwijnen de velden.
*/
(function () {
  var ACCOUNT = '2569663';

  function bericht(form, tekst, fout) {
    var el = form.querySelector('[data-fts-ml-melding]');
    if (!el) {
      el = document.createElement('p');
      el.setAttribute('data-fts-ml-melding', '');
      el.setAttribute('role', fout ? 'alert' : 'status');
      el.className = 'fts-ml-melding';
      form.appendChild(el);
    }
    el.textContent = tekst;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-fts-mailerlite]');
    if (!form) return;
    var id = form.getAttribute('data-fts-mailerlite');
    if (!id) return; // geen ID ingevuld: gewoon naar Shopify
    e.preventDefault();

    var email = form.querySelector('input[type="email"]');
    var naam = form.querySelector('input[name="naam"], input[name="contact[first_name]"]');
    var knop = form.querySelector('[type="submit"]');
    var data = new FormData();
    data.append('fields[email]', email ? email.value.trim() : '');
    if (naam && naam.value.trim()) data.append('fields[name]', naam.value.trim());
    data.append('ml-submit', '1');
    data.append('anticsrf', 'true');

    if (knop) knop.disabled = true;
    fetch('https://assets.mailerlite.com/jsonp/' + ACCOUNT + '/forms/' + id + '/subscribe', {
      method: 'POST',
      body: data,
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (antwoord) {
        if (antwoord && antwoord.success) {
          var bedankt = form.getAttribute('data-fts-ml-bedankt') || 'Bedankt voor je inschrijving!';
          form.querySelectorAll('input, button').forEach(function (el) { el.hidden = true; });
          bericht(form, bedankt, false);
        } else {
          bericht(form, 'Dat lukte niet. Controleer je e-mailadres en probeer het opnieuw.', true);
          if (knop) knop.disabled = false;
        }
      })
      .catch(function () {
        bericht(form, 'Er ging iets mis. Probeer het later nog eens.', true);
        if (knop) knop.disabled = false;
      });
  });
})();
